import styled, { css } from 'styled-components';

export const Header = styled.div`
  padding: ${({ theme }) => `${theme.spacing.x3} ${theme.spacing.x3} ${theme.spacing.x2}`};
  background-color: ${({ theme }) => theme.palette.lightText};
  @media (max-width: ${({ theme }) => theme.media.md}) {
    text-align: center;
  }
`;

export const Content = styled.div`
  padding: ${({ theme }) => `${theme.spacing.x3} ${theme.spacing.x3} ${theme.spacing.x5}`};
  background: ${({ theme }) => theme.palette.white};
  @media (max-width: ${({ theme }) => theme.media.md}) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.palette.white};
  font-size: ${({ theme }) => theme.fs.xs};
  font-weight: 500;
`;

export const LocationWrapper = styled.div`
  padding-inline-start: ${({ theme }) => theme.spacing.x4};
  margin-bottom: ${({ theme }) => theme.spacing.x4};
  position: relative;
`;
export const Location = styled.span`
  font-size: ${({ theme }) => theme.fs.sm};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary};
  display: block;
`;
export const LocationEnd = styled(Location)`
  padding-inline-start: ${({ theme }) => theme.spacing.x5};
  margin-top: ${({ theme }) => theme.spacing.x2};
`;
export const LocationIconWrapper = styled.div<{ $isLTR: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  ${({ $isLTR }) =>
    $isLTR
      ? css`
          left: 0;
        `
      : css`
          right: 0;
          transform: rotateY(180deg);
        `}
`;
export const LocationIcon = styled.div`
  width: ${({ theme }) => theme.spacing.x7};
  height: ${({ theme }) => theme.spacing.x10};
  background-repeat: no-repeat;
  background-size: contain;
`;

export const TinyText = styled.span`
  font-size: ${({ theme }) => theme.fs.xxs};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.lightText};
`;
